export default "__VITE_ASSET__lLoxDqz3__";